export default __webpack_public_path__ + "static/Our-Work-In-Numbers-91f16eb35a8b72b3aa2d1c5527f110c1.webp";